const defaultRender = (value) => (value ? value : "--");

const BookDemoRequest = [
  {
    title: "Firm Name",
    dataIndex: "firm_name",
    render: defaultRender,
  },
  {
    title: "Firm Size",
    dataIndex: "firm_size",
    render: defaultRender,
  },
  {
    title: "Business Email",
    dataIndex: "business_email",
    render: defaultRender,
  },
  {
    title: "First Name",
    dataIndex: "first_name",
    render: defaultRender,
  },
  {
    title: "Last Name",
    dataIndex: "last_name",
    render: defaultRender,
  },
  {
    title: "Location",
    dataIndex: "location",
    render: defaultRender,
  },
  {
    title: "Reference",
    dataIndex: "reference",
    render: defaultRender,
  },
  {
    title: "Phone No",
    dataIndex: "phone_no",
    render: defaultRender,
  },
  // {
  //   title: "Date",
  //   dataIndex: "date",
  //   render: defaultRender,
  // },
  // {
  //   title: "Day",
  //   dataIndex: "day",
  //   render: defaultRender,
  // },
  // {
  //   title: "Time",
  //   dataIndex: "time",
  //   render: defaultRender,
  // },
  {
    title: "Created At",
    dataIndex: "created_at",
    render: defaultRender,
  },
];

export default BookDemoRequest;
